import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContentCustom, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { BetterDocBodyViewer } from "@/modules/admin/better-doc/components/better-doc-body-viewer"

type BetterDocPayloadButtonProps = {
  payload: string
  recordId: number
  testId: string
}

export const BetterDocPayloadButton = ({ payload, recordId, testId }: BetterDocPayloadButtonProps) => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="tertiary"
        className="p-2"
        onClick={() => setIsDialogOpen(true)}
        data-testid={`${testId}-button`}>
        {t("admin.betterDoc.payload.show")}
      </Button>
      {isDialogOpen ? (
        <Dialog open onOpenChange={setIsDialogOpen}>
          <DialogContentCustom className="max-h-[90vh] overflow-y-auto" data-testid={`${testId}-dialog`}>
            <DialogHeader>
              <DialogTitle>{t("admin.betterDoc.payload.dialogTitle", { recordId })}</DialogTitle>
            </DialogHeader>
            <div className="px-6 pb-6">
              <BetterDocBodyViewer title={t("admin.betterDoc.payload.title")} body={payload} testId={testId} />
            </div>
          </DialogContentCustom>
        </Dialog>
      ) : null}
    </>
  )
}
